module.exports = __webpack_public_path__ + "img/YT.5b24e67e.svg";